import { React, useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate  } from 'react-router-dom';
import AOS from 'aos';
import routes from './pages';
import '../src/assets/fonts/font-awesome.css';
import config from './config';
function App() {
    const navigate = useNavigate();
    useEffect(() => {
        AOS.init({
            duration: 2000
        });
        //navigate('/');
    }, []);    
    return (        
        <>
            <Routes>
                {
                    routes.map((data, idx) => (
                        <Route key={idx} path={ config.root + data.path} element={data.component}   />

                    ))
                }
            </Routes>
        </>
    );
}

export default App;